"use client"

import { useState } from 'react'
import Link from 'next/link'
import { useSupabaseAuth } from '../hooks/use-supabase-auth'
import { Auth } from './login/Auth'
import { supabase } from '../lib/supabase'
import { useEffect } from 'react'
import { User } from '@supabase/supabase-js'

export default function HomePage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isSignUp, setIsSignUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const { signIn, signUp } = useSupabaseAuth()
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    // Verificar se usuário já está logado e redirecionar para menu
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (user) {
        // Usuário já está logado, redirecionar para menu
        window.location.href = '/menu'
      } else {
        setUser(user)
      }
    }
    
    checkUser()

    // Escutar mudanças na autenticação
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event: string, session: any) => {
        if (session?.user) {
          // Usuário fez login, redirecionar para menu
          window.location.href = '/menu'
        } else {
          setUser(session?.user || null)
        }
      }
    )

    return () => subscription.unsubscribe()
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      if (isSignUp) {
        await signUp(email, password)
        setError('Cadastro realizado! Verifique seu email para confirmar.')
        // Limpar formulário após cadastro
        setEmail('')
        setPassword('')
        setIsSignUp(false)
      } else {
        await signIn(email, password)
        // Redirecionamento automático será feito pelo useEffect
      }
    } catch (err: any) {
      let errorMessage = err.message || 'Ocorreu um erro. Tente novamente.'
      
      // Tratar erros comuns
      if (errorMessage.includes('Invalid login credentials')) {
        errorMessage = 'Email ou senha incorretos. Verifique seus dados.'
      } else if (errorMessage.includes('email rate limit exceeded')) {
        errorMessage = 'Muitas tentativas. Aguarde alguns minutos e tente novamente.'
      } else if (errorMessage.includes('Email not confirmed')) {
        errorMessage = 'Email não confirmado. Verifique sua caixa de entrada.'
      } else if (errorMessage.includes('User already registered')) {
        errorMessage = 'Email já cadastrado. Tente fazer login.'
      }
      
      setError(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="min-h-screen bg-gradient-to-b from-sky-50 via-slate-50 to-sky-100 px-4 pt-10 pb-48 thumb-safe-area">
      <div className="mx-auto flex h-full max-w-md flex-col justify-center gap-8">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-slate-900 mb-2">
            Circle of Life
          </h1>
          <p className="text-sm text-slate-600">
            Entre com sua conta Google para organizar suas tarefas
          </p>
        </div>

        <div className="rounded-3xl bg-white p-8 shadow-lg ring-1 ring-slate-200">
          <div className="flex justify-center">
            <Auth user={user} />
          </div>
        </div>

        <div className="text-center text-[10px] text-slate-400">
          Seus dados ficam salvos na nuvem com segurança.
        </div>
      </div>
    </main>
  )
}

